export class AcceptInvitationModel {

    public isInit: boolean = true;

    public valid: boolean = false;
    public globalError: string = null;

    public company: string = null;
    public email: string = null;
    public name: string = "";
    public password: string = "";

    public nameError: string = null;
    public passwordError: string = null;

}
